import { render, staticRenderFns } from "./savedTaskCard.vue?vue&type=template&id=431d56b8&"
import script from "./savedTaskCard.vue?vue&type=script&lang=js&"
export * from "./savedTaskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports